<script setup lang="ts">
// Initialize core composables
const { apiClient } = useShopwareContext()
const { changeLanguage } = useInternationalization()
const { getLanguageId } = useLocale()
const { refreshSessionContext } = useSessionContext()

// Initialize other composables
useBreadcrumbs()
useNotifications()
useAddress()

// Setup global title template
useHead({
  titleTemplate: (titleChunk?: string) => {
    if (!titleChunk) return 'Careum'
    // Don't append '| Careum' if it's already present (e.g., from Drupal meta tags)
    return titleChunk.endsWith('| Careum') ? titleChunk : `${titleChunk} | Careum`
  },
})

const { refreshCart } = useCart()

// Initialize language synchronization
const initializeLanguage = async () => {
  try {
    const languageId = await getLanguageId()
    if (languageId) {
      // Update Shopware language context
      await changeLanguage(languageId)

      // Apply language header to API client
      apiClient.defaultHeaders.apply({ 'sw-language-id': languageId })

      // FormKit locale will be handled by the module
    }
  } catch (error) {
    console.error('Error initializing language:', error)
  }
}

// Initialize language and session context on server and client
await initializeLanguage()
await refreshSessionContext()

onMounted(async () => {
  try {
    // Refresh cart (session context already refreshed above)
    await refreshCart()

    // Unregister old service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const registration of registrations) {
          registration.unregister()
        }
      })
    }
  } catch (error) {
    console.error('Error during app initialization:', error)
  }
})
</script>
<template>
  <NuxtLayout>
    <PageLoadingIndicator />
    <NuxtPage />
  </NuxtLayout>
</template>
